import { Link } from 'react-router-dom';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';

import { getRouteBookCatalog } from 'modules/v2/routes/navigation';

import strings from './strings';
import { ORDER_REFUSAL_NOT_IN_PLAN } from './orderOutcome';

interface OrderRefusalAlertProps {
  kind: string | null;
  className?: string;
}

const OrderRefusalAlert = ({ kind, className = '' }: OrderRefusalAlertProps) => {
  if (!kind) {
    return null;
  }

  const isNotInPlan = kind === ORDER_REFUSAL_NOT_IN_PLAN;

  return (
    <div
      role="alert"
      data-testid="order-refusal-alert"
      className={`flex gap-2.5 w-full p-3 rounded-lg bg-red-50 border border-red-200 text-red-900 font-figtree ${className}`}
    >
      <HiOutlineExclamationTriangle size={20} className="flex-none mt-px text-red-700" />
      <div className="flex flex-col gap-1">
        <span className="text-sm font-bold">{strings.refusal.title}</span>
        <span className="text-sm">
          {isNotInPlan ? strings.refusal.notInPlan : strings.refusal.generic}
        </span>
        {isNotInPlan && (
          <Link to={getRouteBookCatalog()} className="text-sm font-semibold text-red-900 underline">
            {strings.refusal.catalogLink}
          </Link>
        )}
      </div>
    </div>
  );
};

OrderRefusalAlert.defaultProps = {
  className: '',
};

export default OrderRefusalAlert;
